export default [
  {
    text:
      "Misiunea companiei nu este doar una comercială ci și de a asigura un produs calitativ și sănătos pe piața locală.",
    icon: "fas fa-warehouse"
  }
  // {
  //   text:
  //     "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",
  //   icon: "fas fa-dolly"
  // }
];
